import { render } from "./LeaderboardPublic.vue?vue&type=template&id=632db0dc&scoped=true"
import script from "./LeaderboardPublic.vue?vue&type=script&lang=js"
export * from "./LeaderboardPublic.vue?vue&type=script&lang=js"

import "./LeaderboardPublic.vue?vue&type=style&index=0&id=632db0dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632db0dc"]])

export default __exports__